<template>
    <div id="tipsPayAtTheTableStatus" v-show="ready">
        <TipBox danger v-if="!isVeloceOrMaitreD" :title="$t('tips.qr_payment.sync_fail.title')" no-border>
            <span v-html="$t('tips.qr_payment.sync_fail.description')"></span>
            <a href="javascript:void(0)" @click="goToPosConfiguration">
                {{$t('tips.qr_payment.configure_pos')}}
                <svgicon src="icon/arrow.svg" :height="13" :width="13"></svgicon>
            </a>
        </TipBox>
        <TipBox success v-if="isVeloceOrMaitreD" :title="$t('tips.qr_payment.sync_success.title')" no-border>
            <span v-html="$t('tips.qr_payment.sync_success.description')"></span>
        </TipBox>

        <TipBox danger v-if="!hasOnlinePayment" :title="$t('tips.qr_payment.online_payment_fail.title')" no-border>
            <span v-html="$t('tips.qr_payment.online_payment_fail.description')"></span>
            <a href="javascript:void(0)" @click="goToPaymentConfiguration">
                {{$t('tips.qr_payment.configure_payment')}}
                <svgicon src="icon/arrow.svg" :height="13" :width="13"></svgicon>
            </a>
        </TipBox>
        <TipBox success v-if="hasOnlinePayment" :title="$t('tips.qr_payment.online_payment_success.title')" no-border>
            <span v-html="$t('tips.qr_payment.online_payment_success.description')"></span>
        </TipBox>
    </div>
</template>

<script>
    import {mapActions} from "vuex";

    export default {
      name: "TipsPayAtTheTable",

      data() {
        return {
          externalPos: null,
          hasOnlinePayment: false,
          ready: false
        }
      },

      computed: {
        isVeloceOrMaitreD() {
          return ["maitre","veloce"].indexOf(this.externalPos) > -1;
        }
      },

      async mounted() {
        this.$store.commit('showSpinner', true);
        try {
            let response = await this.getCompany({ companyId: this.$route.query.company, branchId: this.$route.query.branch, augment: "admin" });
            if (response) {
              this.externalPos = response.activePOS[0];
              this.hasOnlinePayment = response.payments.length > 0 && response.payments[0].processor !== "none";
            } else {
              toast(this.$t("error.no_server"), "error");
            }
        } catch (e) {
          toast(this.$t("error.no_server"), "error");
        }
        this.$store.commit('showSpinner', false);
        if(this.isVeloceOrMaitreD && this.hasOnlinePayment) {
          this.$emit("valid", true);
        } else {
          this.$emit("valid", false);
        }
        this.ready = true;
      },

      methods: {
        ...mapActions(["getCompany"]),

        goToPosConfiguration() {
          let route = this.$router.resolve(this.$router.buildContext("/settings/external-pos"));
          window.open(route.href, "_blank");
        },

        goToPaymentConfiguration() {
          let route = this.$router.resolve(this.$router.buildContext("/settings/payment"));
          window.open(route.href, "_blank");
        }
      },
    }
</script>